import type { Connector } from '../../app/ApiGen';

function compareConnectors(a: Connector, b: Connector): -1 | 0 | 1 {
  const bandA = parseFloat(a.connectorId);
  const bandB = parseFloat(b.connectorId);

  if (bandA > bandB) {
    return 1;
  }
  if (bandA < bandB) {
    return -1;
  }
  return 0;
}

export function sortConnectors(connectors: readonly Connector[]): Connector[] {
  return [...connectors].sort(compareConnectors);
}
